import { GlobalContext } from 'app/store/globalcontext';
import React, { useContext } from 'react';
import TelaBloqueio from '../../components/TelaBloqueio';
import { ValidacaoClienteModais } from '../../ValidacaoClienteModais';

const ModalDesbloqueioSolicitado = () => {
  const [modalValidacaoCliente] = useContext(GlobalContext).modalValidacaoCliente;

  return (
    <TelaBloqueio
      open={modalValidacaoCliente === ValidacaoClienteModais.modalDesbloqueioSolicitado}
      mensagem={
        <>Foi solicitado o desbloqueio para acesso ao sistema. Em breve entraremos em contato para dar continuidade.</>
      }
      hiddenTitle
    />
  );
};

export default ModalDesbloqueioSolicitado;
